import script from "./StudentHelp.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentHelp.vue?vue&type=script&setup=true&lang=js"

import "./StudentHelp.vue?vue&type=style&index=0&id=d0a85aa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0a85aa0"]])

export default __exports__